import React from 'react';
import { SectionHeader } from '@grnhse/seedling/lib/birch/typography';
import { withLocalePrefix } from '../shared/utils/translation';

const t = withLocalePrefix('authorization.authorization_form');

type Props = {
  name: string;
  clientIdHost?: string;
};

export default function ConsentTitle({ name, clientIdHost }: Props) {
  return (
    <SectionHeader>
      {t('title.authorize')} <strong>{name}</strong>{' '}
      {clientIdHost && (
        <>
          <span>{t('title.client_host', { host: clientIdHost })}</span>{' '}
        </>
      )}
      {t('title.to_use_GH_account')}
    </SectionHeader>
  );
}
